<script lang="ts">
    import {onMount} from "svelte";
    import FontAwesomeView from "../../../../../component/common/Image/FontAwesomeView.svelte";

    export let binary;

    $: isJenkins = (() => {
        if (binary.ci_job_url == null) {
            return false;
        }
        if (binary.ci_job_url.includes('jenkins')) {
            return true;
        }

        return false;
    })();

    $: fontAwesomeData = (() => {
        const fontAwesomeData = {icon: 'link', classification: 'fas'};
        if (binary.ci_job_url == null) {
            return fontAwesomeData;
        }
        if (isJenkins) {
            fontAwesomeData.icon = 'jenkins';
            fontAwesomeData.classification = 'fab';
        }
        return fontAwesomeData;
    })();

    $: text = (() => {
        if (isJenkins) {
            return 'Jenkins Job';
        }
        return 'CI Job';
    })();

    onMount(() => {
    });


</script>

<div class="binary-ci-job-link-view">
    {#if binary.ci_job_url != null}
        <a href={binary.ci_job_url} target="_blank" rel="noreferrer noopener">
            <span class="icon">
                <FontAwesomeView icon={fontAwesomeData.icon} classification={fontAwesomeData.classification}/>
            </span>
            <span class="text">
                { text } を開く
            </span>
        </a>
    {/if}


</div>
<style lang="scss">
    .binary-ci-job-link-view {
        display: inline-flex;
        align-items: center;
        justify-content: center;

        > a {
            border-style: solid;
            border-width: 1px;
            border-color: #0003;
            padding-left: 0.5em;
            padding-right: 0.5em;
            border-radius: 0.25em;
            padding-top: 0.25em;
            padding-bottom: 0.25em;

            //background-color: var(--text-color);
            //color: var(--background-color);

            .text {
                font-size: 0.75em;

            }
        }

    }
</style>